export default {
    optionMap: {
        attributions: "setAttributions",
    },
    initialOptionMap: {
        attributions: "attributions",
    },
};
